import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { GetAllUnacceptedCustomersService } from 'src/app/shared/moderator/approve-customer/approve-customer.service';
import { LoginService } from 'src/app/shared/user-login/login.service';

@Component({
    selector: 'app-check-customer',
    templateUrl: './check-customer.component.html',
    styleUrls: ['./check-customer.component.css'],
    standalone: false
})
export class CheckCustomerComponent implements OnInit {

  customer: {}
  loading: boolean = true
  role: string
  serverErrorMessages: string
  serverSuccessMessage: string

  bankingDetails = new FormGroup({
    gstNumber: new FormControl({value:'', disabled: true},
    [Validators.required,
     Validators.minLength(15),
     Validators.maxLength(15)]),
    PAN: new FormControl({value:'', disabled: true},
    [Validators.required,
     Validators.minLength(10),
     Validators.maxLength(10)]),
    currency: new FormControl({value:'', disabled: true},
    [Validators.required]),
    bankName: new FormControl({value:'', disabled: true},
    [Validators.required]),
    bankAccountNumber: new FormControl({value:'', disabled: true},
    [Validators.required]),
    IFSC: new FormControl({value:'', disabled: true},
    [Validators.required,
    Validators.minLength(11),
    Validators.maxLength(11)]),
    SWIFT: new FormControl({value:'', disabled: true},
    [Validators.required,
     Validators.minLength(11),
     Validators.maxLength(11)])
  })
  constructor(private loginService: LoginService, private getAllUnacceptedCustomersService: GetAllUnacceptedCustomersService, private router : Router) { }

  ngOnInit(): void {
    if(this.loginService.isLoggedIn()){
      this.loginService.getUserProfile().subscribe(
        res => {
          this.role = res['user'].role.toString();
         //console.log('User', this.role);
          this.loading = false;
        },
        err => {
         //console.log('Didnt get logged in user', err);
          this.serverErrorMessages = err.error.message;
          this.loading = false;
        }
      )

      this.getAllUnacceptedCustomersService.currentCustomer.subscribe(customer => {
        this.customer = customer;
       //console.log('Inside check customer', this.customer);
      });

      if(Object.keys(this.customer).length === 0){
       //console.log('PLEASE GO BACK')
        window.alert('Please Select a Customer to Approve/Decline')
        this.router.navigateByUrl('get-un-customers')
      }
      else{
        this.bankingDetails.get('gstNumber').setValue(this.customer['gstNumber'])
        this.bankingDetails.get('PAN').setValue(this.customer['PAN'])
        this.bankingDetails.get('currency').setValue(this.customer['currency'])
        this.bankingDetails.get('bankName').setValue(this.customer['bankName'])
        this.bankingDetails.get('bankAccountNumber').setValue(this.customer['bankAccountNumber'])
        this.bankingDetails.get('IFSC').setValue(this.customer['IFSC'])
        this.bankingDetails.get('SWIFT').setValue(this.customer['SWIFT'])
       //console.log(this.bankingDetails.value);
      }
    }
  }

  approve(){
    this.getAllUnacceptedCustomersService.approveCustomer(this.customer).subscribe(
      res=>{
       //console.log('Successfully approved', res)
        alert('Successfully Approved this customer');
        this.router.navigateByUrl('/get-un-customers')
      },
      err=>{
       //console.log('Error in approving', err)
      }
    )
  }

  disapprove(){
    this.getAllUnacceptedCustomersService.disapproveCustomer(this.customer).subscribe(
      res=>{
       //console.log('Successfully disapproved', res)
        alert('Successfully Disapproved this customer');
        this.router.navigateByUrl('/get-un-customers')
      },
      err=>{
       //console.log('Error in approving', err)
      }
    )
  }

}
